export default {"src":"/_next/static/media/oppo_logo.d534d49c.svg","height":62,"width":258};